export const range = (n: number) => Array.from({ length: n }, (_, i) => i);

export const minMax = (arr: number[]): { min: number; max: number } => {
  if (!arr.length) {
    return { min: 0, max: 0 };
  }
  const min = Math.min(...arr);
  const max = Math.max(...arr);
  return { min, max };
};

export const uniq = <T>(arr: T[]): T[] => Array.from(new Set(arr));
